import '@/common/style/index.styl'

import { mapState, mapActions } from 'vuex'
import Utils from '@/common/js/utils'
import moduleList from '@/modules'
import NotFoundModule from './not-found-module/index'
import fontSizeMixin from '@/common/js/font-size-mixin'

const DELAY_TIME = 20

const page403 = {
  beforeCreate() {
    this.$audio.hide()
  },
  render() {
    return (
      <div class="page page-403">
        <msg
          title=""
          description={this.$store.state.eventRuntime.deniedReason}
          icon="warn"
        />
      </div>
    )
  }
}

const wechat = {
  name: 'wechat',
  mixins: [fontSizeMixin],
  computed: mapState('eventRuntime', {
    selectedPage: state => {
      return state.selectedPage
    }
  }),
  // 别删
  components: {
    page403
  },
  watch: {
    selectedPage(newVal, oldVal) {
      this.$nextTick(_ => {
        this.windowResizeHandler()
      })
    }
  },
  mounted() {
    this.windowResizeHandler()
    window.addEventListener('resize', this.windowResizeHandler)
    // 监听 哈希路由变化
    this.windowPopstateHandler()
    window.addEventListener('popstate', this.windowPopstateHandler)
  },
  methods: {
    windowPopstateHandler: Utils.throttle(async function() {
      this.currentRoute = window.location.hash.includes('?') ? window.location.hash.replace(/#/, '').replace(/\?\S+/g, '') : window.location.hash.replace(/#/, '').replace(/\//g, '')
      if (!this.currentRoute) {
        this.resetSelectedPage()
        return false
      }
      const module = (await moduleList[window.SELECTED_MODULE]()).default
      if (module.pages.some(d => d.id === this.currentRoute)) {
        this.changeSelectedPage(this.currentRoute)
      } else {
        this.changeSelectedPage('notFoundPage')
      }
      this.$nextTick(() => {
        this.windowResizeHandler()
      })
    }, DELAY_TIME),
    ...mapActions({
      changeSelectedPage: 'eventRuntime/changeSelectedPage',
      resetSelectedPage: 'eventRuntime/resetSelectedPage'
    })
  },
  render() {
    const Page = this.selectedPage

    if (Page === '403') {
      return <page-403 />
    }
    
    return <Page />
  }
}

const getAsyncComponent = async () => {
  const module = (await moduleList[window.SELECTED_MODULE]()).default
  module.pages.forEach(pageItem => {
    wechat.components[pageItem.id] = pageItem.component
  })
  wechat.components['notFoundPage'] = NotFoundModule
  return wechat
}

export default getAsyncComponent